module.exports = __webpack_public_path__ + "img/close-brothers-logo.78a4b717.svg";